<script>
    import Chip, { Set, LeadingIcon, Text } from "@smui/chips";
    import {
        Card,
        CardText,
        CardTitle,
        CardSubtitle,
        CardActions,
        Badge,
        Menu,
        List,
        ListItem,
        ProgressLinear,
        TextField,
        Button,
        Icon,
        AppBar,
        Switch,
        Radio,
        MaterialApp,
        Footer,
    } from "svelte-materialify/src";
    import {
        mdiDotsVertical,
        mdiMagnify,
        mdiFilter,
        mdiArrowExpandAll,
        mdiHome,
    } from "@mdi/js";
    import * as d3 from "d3";
    import { onMount } from "svelte";
    import * as hagrid from "@saehrimnir/hagrid";
    //console.log(hagrid);
    import { Delaunay } from "d3-delaunay";
    export let vislogo;

    let data = [];
    let colortable = {};
    let T = d3.zoomIdentity;
    let zoom;
    let app;
    let preload;
    let W;
    let H;

    let projections = [
        {
            name: "Supervised modeling (logo/genre classifier)",
            description:
                "UMAP using a neural network of logo images predicting the genres. Transfer learning using the Inception v3 architecture.",
            file: "new_metaldata_inception_2.csv",
        },
        {
            name: "Unsupervised modeling (logo VAE)",
            description:
                "Variational auto encoder (VAE) trained on simplified logos to encode logos into a 2D latent space.",
            file: "new_metaldata_latent_space.csv",
        },
        {
            name: "Projection (genre)",
            description:
                "UMAP using the Sokal-Michener distance on the genres. Logos did not get used!",
            file: "new_metaldata_sokalmichener_2.csv",
        },
        {
            name: "Projection (color)",
            description:
                "UMAP using the Bhattacharyya distance between color histograms (all 3 color channels, 16 bins for each channel, counting all pixels) of the band logos.",
            file: "new_metaldata_color_histogram.csv",
        },
        /* {
            name: "by image (latent space)",
            description: "by frank.",
            file: "metaldata_latent_space.csv",
        },
        {
            name: "by image (neural network)",
            description: "UMAP using a neural network predicting the genres. Transfer learning using the Inception v3 architecture.",
            file: "metaldata_inception.csv",
        },
        {
            name: "by color and genre (v3)",
            description:
                "Supervised UMAP with jaccard metric on genres, using the Bhattacharyya distance between histograms (all 3 color channels, 16 bins for each channel, counting all pixels)",
            file: "metaldata_histogram_bhattacharyya_3_genres.csv",
        },
        {
            name: "by color (v3)",
            description:
                " UMAP using the Bhattacharyya distance between histograms (all 3 color channels, 16 bins for each channel, counting all pixels)",
            file: "metaldata_histogram_bhattacharyya_3.csv",
        },
        {
            name: "by color and genre (v2.2)",
            description:
                "Supervised UMAP with jaccard metric on genres (with lower weight), using the Bhattacharyya distance between histograms (all 3 color channels, 16 bins for each channel, counting pixels with color value above 16)",
            file: "metaldata_histogram_bhattacharyya_2_genres_2.csv",
        },
        {
            name: "by color and genre (v2.1)",
            description:
                "Supervised UMAP with jaccard metric on genres, using the Bhattacharyya distance between histograms (all 3 color channels, 16 bins for each channel, counting pixels with color value above 16)",
            file: "metaldata_histogram_bhattacharyya_2_genres.csv",
        },
        {
            name: "by color (v2)",
            description:
                "UMAP using the Bhattacharyya distance between histograms (all 3 color channels, 16 bins for each channel, counting pixels with color value above 16)",
            file: "metaldata_histogram_bhattacharyya_2.csv",
        },
        {
            name: "by color (Chi squared)",
            description:
                "UMAP using the Chi Squared distance between histograms (all 3 color channels, 16 bins for each channel, counting pixels with color value above 16)",
            file: "metaldata_histogram_chisqr.csv",
        },
        {
            name: "by color and genre (v1)",
            description:
                "Supervised UMAP with jaccard metric on genres, using the Bhattacharyya distance between histograms (all 3 color channels, 8 bins for each channel, counting pixels with color value above 16)",
            file: "metaldata_histogram_bhattacharyya_genres_2.csv",
        },
        {
            name: "by color (v1)",
            description:
                "UMAP using the Bhattacharyya distance between histograms (all 3 color channels, 8 bins for each channel, counting pixels with color value above 16)",
            file: "metaldata_histogram_bhattacharyya.csv",
        },
        {
            name: "by color (euclidean)",
            description:
                "UMAP using Euclidean distance between histograms (without normalization)",
            file: "metaldata_histogram_distance_2.csv",
        },
        {
            name: "by color (correlation)",
            description:
                "UMAP using correlation between histograms (without normalization)",
            file: "metaldata_histogram_correlation.csv",
        },
        {
            name: "by genre (hellinger)",
            description:
                "UMAP using the hellinger distance on the genres. Logos did not get used!",
            file: "metaldata_hellinger.csv",
        },
        {
            name: "by image (ssim)",
            description: "UMAP using structural similarity between images",
            file: "metaldata.csv",
        }, */
    ];
    let selectedData = projections[0];

    let genres =
        "death|black|thrash|heavy|power|progressive|doom|gothic|grind|rock|speed|groove|hard|folk|industrial|pagan|sludge|nwobhm|crossover|stoner|hardcore|epic|avant-garde|core|viking|punk|dark|alternative|electronic|nu|melodic|brutal|symphonic|technical|atmospheric|ambient|raw|experimental|blackened|extreme|depressive|southern|psychedelic|post|glam|grunge|neo|acoustic|orchestral|classical|funeral".split(
            "|"
        );

    function getPrimGenre(genrestring) {
        let g = genrestring.toLowerCase();
        return genres.filter((genre) => g.search(genre) >= 0)[0] || null;
    }

    let filterString = "";
    $: filterBands(filterString);

    function filterBands(filterString) {
        let filters = filterString
            .toLowerCase()
            .split("|")
            .map((str) =>
                str
                    .split(" ")
                    .filter(
                        (d) => genres.includes(d) || genres.includes(d.slice(1))
                    )
            )
            .filter((d) => d.length != 0);
        let actualFilterString = filters
            .map((F) => F.join(" and "))
            .join(" or ");
        //console.log(actualFilterString);
        if (actualFilterString == "") {
            data.forEach((band) => {
                band.logo.alpha = 1;
            });
        } else {
            //let selection = data.map(d => true);
            data.forEach((band) => {
                let show = filters
                    .map((F) =>
                        F.map((f) => {
                            if (f[0] == "!" || f[0] == "-") {
                                return !band.genre
                                    .toLowerCase()
                                    .includes(f.slice(1));
                            } else {
                                return band.genre.toLowerCase().includes(f);
                            }
                        }).reduce((a, b) => a && b, true)
                    )
                    .reduce((a, b) => a || b, false);
                band.logo.alpha = show ? 1 : 0.05;
            });
        }
    }

    let selectedGenres = genres.slice();
    let filterType = "can";

    $: hide_genres(selectedGenres, filterType);

    function hide_genres(selectedGenres, filterType) {
        data.forEach((band) => {
            let show = false;
            if (filterType == "can") {
                selectedGenres.forEach((g) => {
                    if (band.genre.toLowerCase().includes(g)) {
                        show = true;
                    }
                });
            } else if (filterType == "must") {
                let res = selectedGenres.map((g) =>
                    band.genre.toLowerCase().includes(g)
                );
                show = res.reduce((a, b) => a && b, true);
            } else if (filterType == "only") {
                let res = genres.map((G) => {
                    let gg = band.genre.toLowerCase().includes(G);
                    return selectedGenres.includes(G) ? gg : !gg;
                });
                show = res.reduce((a, b) => a && b, true);
            }

            band.logo.alpha = show ? 1 : 0.05;
        });
    }

    async function switchData(selectedData) {
        let csvdata = await d3.csv(selectedData.file, d3.autoType);
        //console.log(csvdata);
        csvdata.forEach((band) => {
            band.name = band.name.toString();
            band.primaryGenre = getPrimGenre(band.genre);
        });

        //csvdata = csvdata.slice(0, 200);

        const values = csvdata.map((d) => [d.x, d.y]);
        const grid = await hagrid.gridify(values, "hilbert", { pluslevel: 0 });
        csvdata.forEach((row, i) => {
            row.gx = grid[i][0];
            row.gy = grid[i][1];
        });

        x = d3
            .scaleLinear()
            .domain(d3.extent(csvdata, (d) => d.x))
            .range([(W - width) / 2, (W + width) / 2]);
        y = d3
            .scaleLinear()
            .domain(d3.extent(csvdata, (d) => d.y))
            .range([margin, height - margin]);
        gx = d3
            .scaleLinear()
            .domain(d3.extent(csvdata, (d) => d.gx))
            .range([(W - width) / 2, (W + width) / 2]);
        gy = d3
            .scaleLinear()
            .domain(d3.extent(csvdata, (d) => d.gy))
            .range([margin, height - margin]);

        size = Math.min(gx(1) - gx(0) - 2, 15);

        data.forEach((band, i) => {
            band.x = values[i][0];
            band.y = values[i][1];
            band.gx = grid[i][0];
            band.gy = grid[i][1];
        });

        change_to_grid(gridified);
        highlightBands(searchString);
        drawContours();
    }
    $: switchData(selectedData);

    window.onresize = () => {
        W = main.innerWidth;
        H = main.innerHeight;
    };
    let loading = true;
    let progress = 0;
    let highlightContainer;
    let bgContainer;
    let container;
    let toucanContainer;

    let easteregg = "abbath";
    let eastereggString = "";
    
    window.onkeypress = (event) => {
        eastereggString += event.key;
        eastereggString = eastereggString.slice(-easteregg.length)
        if (eastereggString == easteregg) {
            toucanContainer.alpha = 1;
        } else if (eastereggString == "toucan") {
            if (mainGenres.length == 4) {
                mainGenres.splice(0, 0, {genre: "doom", color: "#663399", name: "Doom Metal", show: true });
                mainGenres = mainGenres;
                drawContours();
            }
        }
    }

    onMount(async () => {
        W = window.innerWidth;
        H = window.innerHeight;
        app = new PIXI.Application({
            width: W,
            height: H,
            antialias: true,
            resolution: window.devicePixelRatio || 1,
            resizeTo: window,
        });
        bgContainer = new PIXI.Container();
        highlightContainer = new PIXI.Container();
        container = new PIXI.Container();
        toucanContainer = new PIXI.Container()
        toucanContainer.alpha = 0;
        container.interactive = true;
        container.sortableChildren = true;
        app.stage.addChild(bgContainer);
        app.stage.addChild(container);
        app.stage.addChild(highlightContainer);
        app.stage.addChild(toucanContainer);

        //console.log(main)
        main.appendChild(app.view);
        let csvdata = await d3.csv(selectedData.file, d3.autoType);
        /* colortable = (await d3.csv("./pallete_full.csv", d3.autoType)).map(({id, palette}) => {
            return {
                "id": id,
                "colors": palette.split("|").map(d3.color)
            }
        }); */
        (await d3.csv("./palette_full.csv", d3.autoType)).forEach(
            ({ id, palette }) => {
                colortable[id] = palette.split("|").map(d3.color);
            }
        );

        csvdata.forEach((band) => {
            band.name = band.name.toString();
            band.primaryGenre = getPrimGenre(band.genre);
        });

        //csvdata = csvdata.slice(0, 200);

        const values = csvdata.map((d) => [d.x, d.y]);
        const grid = await hagrid.gridify(values, "hilbert", { pluslevel: 0 });
        csvdata.forEach((row, i) => {
            row.gx = grid[i][0];
            row.gy = grid[i][1];
        });
        x = d3
            .scaleLinear()
            .domain(d3.extent(csvdata, (d) => d.x))
            .range([(W - width) / 2, (W + width) / 2]);
        y = d3
            .scaleLinear()
            .domain(d3.extent(csvdata, (d) => d.y))
            .range([margin, height - margin]);
        gx = d3
            .scaleLinear()
            .domain(d3.extent(csvdata, (d) => d.gx))
            .range([(W - width) / 2, (W + width) / 2]);
        gy = d3
            .scaleLinear()
            .domain(d3.extent(csvdata, (d) => d.gy))
            .range([margin, height - margin]);
        size = Math.min(gx(1) - gx(0) - 2, 15);

        const loader = PIXI.Loader.shared;

        let P = new Promise((res) => {
            loader.onComplete.add(() => {
                progress = 1;
                res();
            });
        });

        csvdata.forEach((band, i) => {
            if (band.label == "Tundra Toucan") {
                loader.add(`${i}`, band.url);
            } else {
                loader.add(`${i}`, `./thumbnails/${band.id}.png`);
            }
        });
        console.log(csvdata)
        loader.onProgress.add((event) => {
            progress = event.progress / 100;
        });

        loader.load((loader, resources) => {
            for (const [key, value] of Object.entries(resources)) {
                const band = csvdata[key];
                const bandlogoContainer = new PIXI.Container();
                bandlogoContainer.x = x(band.x);
                bandlogoContainer.y = y(band.y);
                band.logo = bandlogoContainer
                const sprite = PIXI.Sprite.from(value.texture);
                const { height, width } = value.texture.orig;
                band.width = width;
                band.height = height;
                sprite.anchor.x = 0.5;
                sprite.anchor.y = 0.5;
                sprite.width = size;
                sprite.height = (size / width) * height;
                bandlogoContainer.addChild(sprite);

                if (band.label == "Tundra Toucan") {
                    sprite.width *= 2;
                    sprite.height *= 2;
                    //bandlogo.alpha = 0;
                    const g = new PIXI.Graphics();
                    g.lineStyle(3, 0xffffff, 1, 1);
                    g.drawRect(-sprite.width / 2, -sprite.height / 2, sprite.width, sprite.height);
                    //band.toucanRect = g;
                    bandlogoContainer.addChild(g);
                    toucanContainer.addChild(bandlogoContainer);
                } else {
                    container.addChild(bandlogoContainer);
                }
            }
        });

        // death|black|thrash|heavy
        /* let genre_colors = [
            "#B22222", "#FBFCFC", "#AED6F1", "#F7DC6F"
        ]
        genres.slice(0, 4).forEach((genre, i) => {
            let bands = csvdata.filter(d => d.primaryGenre == genre);
            let centroid = [
                d3.mean(bands, b => b.x),
                d3.mean(bands, b => b.y)
            ]
            let radius = d3.mean(bands, b => Math.hypot(x(b.x - centroid[0]), y(b.y - centroid[1])))
            console.log(genre, centroid, radius)

            const circle = new PIXI.Graphics()
            circle.beginFill(PIXI.utils.string2hex(genre_colors[i]))
            circle.drawCircle(x(centroid[0]), y(centroid[1]), radius / 2);
            circle.endFill();
            circle.alpha = 0.1
            circle.zIndex = - 10
            container.addChild(circle)
        }) */

        await P;
        data = csvdata;

        delaunay = Delaunay.from(
            data,
            (d) => x(d.x),
            (d) => y(d.y)
        );

        zoom = d3
            .zoom()
            .extent([
                [0, 0],
                [width, height],
            ])
            .scaleExtent([0.5, 16])
            .on("zoom", zoomed);
        d3.select(app.view).call(zoom);

        function zoomed({ transform }) {
            T = transform;
            [toucanContainer, bgContainer, highlightContainer, container].forEach(
                (container) => {
                    container.transform.scale.x = T.k;
                    container.transform.scale.y = T.k;
                    container.x = T.x;
                    container.y = T.y;
                }
            );
        }

        container.on("mousemove", (event) => {
            let { x, y } = event.data.getLocalPosition(container);
            let { x: gx, y: gy } = event.data.global;
            let h = delaunay.find(x, y);
            let { x: mx, y: my } = (mouse = data[h].logo.getGlobalPosition());
            highlight =
                Math.hypot(gx - mx, gy - my) < 50 && data[h].logo.alpha == 1
                    ? h
                    : null;

            if (data[h].label == "Tundra Toucan" && toucanContainer.alpha == 0) {
                highlight = null;
            }
            //console.log(delaunay.find(x, y))

            if (highlight != null) {
                data.forEach((band, i) => {
                    if (!band.logo) return;
                    const aspect_ratio = band.logo.width / band.logo.height;
                    const select = i == highlight;
                    /* band.logo.width = select ? 2 * size : size;
                    band.logo.height = band.logo.width / aspect_ratio; */
                    band.logo.zIndex = select ? 9999 : 1;
                });

                if (h != null) {
                    d3.select(tooltip)
                        .style("display", "block")
                        .style(
                            "left",
                            mouse.x < main.clientWidth / 2
                                ? `${mouse.x + 25}px`
                                : null
                        )
                        .style(
                            "right",
                            mouse.x >= main.clientWidth / 2
                                ? `${main.clientWidth - mouse.x + 25}px`
                                : null
                        )
                        .style(
                            "top",
                            mouse.y < main.clientHeight / 2
                                ? `${mouse.y + 25}px`
                                : null
                        )
                        .style(
                            "bottom",
                            mouse.y >= main.clientHeight / 2
                                ? `${main.clientHeight - mouse.y + 25}px`
                                : null
                        );
                }
            } else {
                d3.select(tooltip).style("display", "none");
            }
        });
        drawContours();
        loading = false;
    });

    let mainGenres = [
        //{ genre: "doom", color: "#0f0", name: "Doom Metal", show: true },
        { genre: "heavy", color: "#DAA520", name: "Heavy Metal", show: true },
        { genre: "thrash", color: "#4682B4", name: "Thrash Metal", show: true },
        { genre: "death", color: "red", name: "Death Metal", show: true },
        { genre: "black", color: "white", name: "Black Metal", show: true },
    ];

    $: drawContours(mainGenres);
    function drawContours() {
        if (!bgContainer || !data.length > 0) return;

        bgContainer.removeChildren();
        for (const G of mainGenres) {
            if (!G.show) continue;
            //console.log(W)
            const size = [W, W];
            let contours = d3
                .contourDensity()
                .x((d) => (gridified ? gx(d.gx) : x(d.x)))
                .y((d) => (gridified ? gy(d.gy) : y(d.y)))
                .size(size)
                .bandwidth(25)
                .thresholds(15)(
                data.filter((band) =>
                    band.genre.toLowerCase().includes(G.genre)
                )
            );
            G.contours = contours;
        }

        //const max = d3.max(mainGenres, d => d3.max(d.contours, d => d.value));
        //console.log(mainGenres)
        for (const G of mainGenres) {
            if (!G.show) continue;
            const contours = G.contours
            const s = d3
                .scaleSequential(d3.interpolateLab("black", G.color))
                .domain([0, d3.max(contours, (d) => d.value)]);
            const o = d3
                .scaleLinear()
                .domain([0, d3.max(contours, (d) => d.value)])
                .range([0, 0.12]);

            let N = contours.length;
            for (let i = 0; i < N; ++i) {
                const c = contours[i];
                //console.log(c);
                const g = new PIXI.Graphics();
                const color = rgb2hex(d3.color(s(c.value)));
                const opacity = o(c.value);
                g.beginFill(color, opacity);
                for (const p of c.coordinates) {
                    g.drawPolygon(p[0].flat());
                }
                g.endFill();
                bgContainer.addChild(g);
            }
        }
    }

    function rgb2hex({ r, g, b }) {
        return (r * 256 + g) * 256 + b;
    }

    let highlight;

    const width = 1500;
    const height = 1500;
    const margin = 50;
    let x = () => 0;
    let y = () => 0;
    let gx = () => 0;
    let gy = () => 0;
    let size = 30;
    let delaunay;
    let searchString = "";
    let main;

    $: highlightBands(searchString);

    function highlightBands(str) {
        if (!highlightContainer) return;
        if (str.length < 3) {
            highlightContainer.removeChildren();
            return;
        }
        let filter = data.filter((band) => {
            return band.name.toLowerCase().includes(str);
        });
        highlightContainer.removeChildren();
        filter.forEach((band) => {
            const g = new PIXI.Graphics();
            g.lineStyle(1, 0xffffff, 1);
            if (gridified) {
                g.drawCircle(gx(band.gx), gy(band.gy), 20);
            } else {
                g.drawCircle(x(band.x), y(band.y), 20);
            }
            highlightContainer.addChild(g);
        });
    }

    let menu;
    let gridified = false;

    $: change_to_grid(gridified);

    function change_to_grid(grid) {
        highlightBands(searchString);
        let xa, ya;
        if (grid) {
            xa = (d) => gx(d.gx);
            ya = (d) => gy(d.gy);
        } else {
            xa = (d) => x(d.x);
            ya = (d) => y(d.y);
        }

        data.forEach((band) => {
            const { width, height } = band;
            band.logo.x = xa(band);
            band.logo.y = ya(band);
            band.logo.width = size;
            band.logo.height = (size / width) * height;
            
            if (band.label == "Tundra Toucan") {
                band.logo.width *= 2;
                band.logo.height *= 2;
            }
        });

        delaunay = Delaunay.from(data, xa, ya);

        drawContours();
    }

    let tooltip;
    let mouse = { x: 0, y: 0 };
    /* let menu_open = false;

    $: addlistener(menu);
    function addlistener(node) {
        if (node) {
            console.log("addlistener", node);
            let el = node.getElement();
            console.log(el);
            console.log(el.style.display);
            el.addEventListener("close", () => {
                console.log("list close");
                menu_open = false;
            });
        }
    } */
</script>

<MaterialApp theme="dark">
    {#if !loading}
        <AppBar tile style="background-color: black;">
            <span
                slot="title"
                style="display: flex; align-content: center; align-items: center; font-family: 'Metal Mania';"
            >
                Metal
                <img src={vislogo} alt="VIS" style="height: 1.5em;" />
            </span>
            <div style="flex-grow:1" />
            <div>
                <TextField
                    solo
                    clearable
                    placeholder="search for bandname"
                    bind:value={searchString}
                >
                    <div slot="prepend">
                        <Icon path={mdiMagnify} />
                    </div>
                </TextField>
            </div>
            <div style="flex-grow:1" />
            <!-- <div style="width: 350px" class="ml-4 mr-4">
                <TextField
                    clearable
                    placeholder="filter genres"
                    bind:value={filterString}
                >
                    <div slot="prepend">
                        <Icon path={mdiFilter} />
                    </div>
                </TextField>
            </div> -->
            <div class="ml-4 mr-4">
                <Switch bind:checked={gridified} inset>Gridified</Switch>
            </div>
            <Menu right>
                <div slot="activator">
                    <Button fab depressed style="background-color: black;">
                        <Icon path={mdiDotsVertical} />
                    </Button>
                </div>
                <List>
                    {#each projections as p}
                        <ListItem
                            selectable
                            active={selectedData == p}
                            on:click={() => {
                                selectedData = p;
                            }}
                        >
                            {p.name}
                            <span slot="subtitle">{p.description}</span>
                        </ListItem>
                    {/each}
                </List>
            </Menu>
        </AppBar>
    {/if}
    <main bind:this={main}>
        <div style="display: {loading ? 'none' : 'block'}">
            <div
                class="flexy"
                style="
                    position: absolute;
                    bottom: 1em;
                    left: 1em;
                "
            >
                {#each mainGenres as { name, color, active }, i}
                    <Switch
                        {color}
                        inset
                        style="color: {color}; font-family: 'Metal Mania'"
                        bind:checked={mainGenres[i].show}>{name}</Switch
                    >
                    <!-- <span style="color: {color}; font-family: 'Metal Mania'">⬤ {name}</span>
                    <br /> -->
                {/each}
            </div>
            <div
                class="flexy"
                style="
                    position: absolute;
                    bottom: 1em;
                    right: 1em;
                "
            >
                <div class="margins">
                    <Menu
                        bottom
                        right
                        closeOnClick={false}
                        closeOnClickOutside={true}
                    >
                        <div slot="activator">
                            <Badge
                                class="primary-color"
                                offsetX={24}
                                offsetY={24}
                            >
                                <Button
                                    fab
                                    size="large"
                                    style="background-color: #222; color: white;"
                                >
                                    <Icon path={mdiFilter} />
                                </Button>
                                <span slot="badge">
                                    {#if selectedGenres.length != genres.length}
                                        {selectedGenres.length}
                                    {/if}
                                </span>
                            </Badge>
                        </div>
                        <Card style="width: 90vw; height: 25vh;" tile raised>
                            <CardTitle>Filter</CardTitle>
                            <CardText>
                                <div class="d-flex mb-2" style="gap: 1em;">
                                    <Radio bind:group={filterType} value="can"
                                        >can contain</Radio
                                    >
                                    <Radio bind:group={filterType} value="must"
                                        >must contain</Radio
                                    >
                                    <Radio bind:group={filterType} value="only"
                                        >contains only</Radio
                                    >
                                </div>
                                <Set
                                    chips={genres}
                                    let:chip
                                    filter
                                    bind:selected={selectedGenres}
                                >
                                    <Chip
                                        {chip}
                                        style="background-color: {selectedGenres.includes(
                                            chip
                                        )
                                            ? '#B73239'
                                            : '#555'}; color: white;"
                                    >
                                        <LeadingIcon class="material-icons"
                                            >close</LeadingIcon
                                        >
                                        <Text tabindex="0">{chip}</Text>
                                    </Chip>
                                </Set>
                            </CardText>
                            <CardActions class="float-right">
                                <Button
                                    text
                                    class="primary-text"
                                    on:click={() =>
                                        (selectedGenres = genres.slice())}
                                    >Select All</Button
                                >
                                <Button
                                    text
                                    class="primary-text"
                                    on:click={() => (selectedGenres = [])}
                                    >Select None</Button
                                >
                            </CardActions>
                        </Card>
                    </Menu>
                    <Button
                        fab
                        size="large"
                        style="background-color: #222; color: white;"
                        on:click={() =>
                            d3
                                .select(app.view)
                                .call(zoom.transform, d3.zoomIdentity)}
                    >
                        <Icon path={mdiArrowExpandAll} />
                    </Button>
                </div>
            </div>
        </div>
        <div id="tooltip" bind:this={tooltip} style="display: none">
            {#if highlight != null}
                <Card
                    style="background-color: #222; min-width: 350px !important;"
                >
                    <CardTitle>{data[highlight].name}</CardTitle>
                    <CardSubtitle>{data[highlight].genre}</CardSubtitle>
                    <div class="pt-2 pb-2" style="background-color: black;">
                        <img
                            src={data[highlight].url}
                            alt="bandlogo"
                            style="object-fit: contain; width: 350px; max-height: 200px;"
                        />
                    </div>
                    <div class="pl-4 pr-4 pt-2 pb-2">
                        {#if data[highlight].label != "Tundra Toucan"}
                            {#each colortable[data[highlight].id] as c}
                                <span style="color: {c.toString()}">⬤</span>
                            {/each}
                        {/if}
                        <br />
                        {data[highlight].themes}
                    </div>
                </Card>
            {/if}
        </div>
        {#if loading}
            <div id="loader">
                <span
                    style="font-size: 48px; display: flex; align-content: center; justify-content: center; align-items:center; width: 100%; color: white;"
                >
                    Metal<img src={vislogo} alt="VIS" style="height: 1.5em;" />
                </span>
                <!-- <CircularProgress
                    color="red"
                    style="height: 100px; width: 100px;"
                    {progress}
                    indeterminate={progress == 1}
                /> -->
                <ProgressLinear color="primary" value={progress * 100} />
                <span
                    style="display: flex; align-content: center; justify-content: center; width: 100%; color: white; text-align: center;"
                >
                    {Math.ceil(progress * 100)}%
                    <br />
                    soundcheck...
                </span>
            </div>
        {/if}
    </main>
    <Footer
        absolute
        padless
        class="theme--dark d-flex"
        style="background-color: black;"
    >
        <div>
            <!-- <Button
                icon
                on:click={async () =>
                    (window.location.href = "https://renecutura.eu")}
                ><Icon class="secondary-text" path={mdiHome} /></Button
            > -->
            <a href="https://renecutura.eu"
                ><Icon class="secondary-text" path={mdiHome} /></a
            >
        </div>
        <div style="flex-grow:1" />
        <div>
            <!-- <Button
                text
                on:click={() =>
                    (window.location.href =
                        "https://noeska.github.io/illegiblesemantics/")}
                class="secondary-text">Illegible Semantics</Button
            > -->
            <a
                href="https://noeska.github.io/illegiblesemantics/"
                class="secondary-text text">Illegible Semantics</a
            >
        </div>
        <div style="flex-grow:1" />
    </Footer>
</MaterialApp>

<style>
    main {
        position: relative;
        width: 100vw;
        height: calc(100vh - 6em);
        padding: 0;
        margin: 0;
        font-family: sans-serif;
    }

    #loader {
        background-color: black;
        font-family: "Metal Mania";
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        align-content: center;
        z-index: 9999;
        gap: 0.5em;
    }

    #tooltip {
        pointer-events: none;
        width: 350px;
        position: absolute;
    }
</style>
